import { useMemo } from 'react';
import { getAvailableFields } from 'shared/domain/visibleField/availableFields';
import { createAvailableFieldsSet } from 'shared/domain/visibleField/createAvailableFieldsSet';
import { useProcesses } from 'store/process';
import { useVisibleFieldsByProcess } from 'store/visibleFields';

/** Issue fields visible in the project – filters with a hidden `fieldRelation` are not shown. */
export function useChartAvailableFieldsSet(): Set<string> {
  const visibleFields = useVisibleFieldsByProcess();
  const { processes } = useProcesses();

  return useMemo(
    () =>
      createAvailableFieldsSet(
        visibleFields,
        getAvailableFields().filter((field) => !field.canBeDisabled),
        processes
      ),
    [visibleFields, processes]
  );
}
